/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetLicenseAvailableFeatures$Request {
    licenseId: number;
}

export interface GetLicenseAvailableFeatures$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseAvailableFeaturesRequest = createAction<PayloadData<void, GetLicenseAvailableFeatures$Request>>('GET_LICENSE_AVAILABLE_FEATURES__GET_LICENSE_AVAILABLE_FEATURES__REQUEST');
export const getLicenseAvailableFeaturesSuccess = createAction<PayloadData<Array<DictionaryItem>, GetLicenseAvailableFeatures$Request>>('GET_LICENSE_AVAILABLE_FEATURES__GET_LICENSE_AVAILABLE_FEATURES__SUCCESS');
export const getLicenseAvailableFeaturesFailure = createAction<PayloadData<Error, GetLicenseAvailableFeatures$Request, true>>('GET_LICENSE_AVAILABLE_FEATURES__GET_LICENSE_AVAILABLE_FEATURES__FAILURE');

export const getLicenseAvailableFeaturesActions = [
    getLicenseAvailableFeaturesRequest,
    getLicenseAvailableFeaturesSuccess,
    getLicenseAvailableFeaturesFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseAvailableFeatures = (meta: GetLicenseAvailableFeatures$Request, config?: GetLicenseAvailableFeatures$Config) => {
    return {
        CALL_API: {
            types: getLicenseAvailableFeaturesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/licenses/${meta.licenseId}/available-features`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

